//FEEDBACK MUTATIONS
export const SET_FEEDBACK = "SET_FEEDBACK"
export const RESET_FEEDBACK = "RESET_FEEDBACK"